<h3 class="m-0 mb-2 px-1 text-lg font-bold">{{ title }}</h3>

<app-card [noMargin]="true" [showHeader]="false">
    <div card-body class="health-body">
        @if (loading) {
            <app-loading-indicator></app-loading-indicator>
        } @else {
            <!-- Open, then monitoring, then overdue: the order work moves through. -->
            <div class="summary-row">
                <button
                    type="button"
                    class="summary"
                    [class.active]="activeFilter === 'open'"
                    (click)="toggleFilter('open')">
                    <span class="summary-value">{{ summary.open }}</span>
                    <span class="summary-label">Open</span>
                </button>
                <button
                    type="button"
                    class="summary"
                    [class.watch]="summary.monitoring > 0"
                    [class.active]="activeFilter === 'monitoring'"
                    (click)="toggleFilter('monitoring')">
                    <span class="summary-value">{{ summary.monitoring }}</span>
                    <span class="summary-label">Monitoring</span>
                </button>
                <button
                    type="button"
                    class="summary"
                    [class.alert]="summary.overdue > 0"
                    [class.active]="activeFilter === 'overdue'"
                    (click)="toggleFilter('overdue')">
                    <span class="summary-value">{{ summary.overdue }}</span>
                    <span class="summary-label">Overdue</span>
                </button>
            </div>

            @if (expanded) {
                <div class="legend">
                    <span class="legend-item"><i class="swatch open"></i>{{ legendOpen }}</span>
                    <span class="legend-item"><i class="swatch monitoring"></i>{{ legendMonitoring }}</span>
                    <span class="legend-item"><i class="swatch overdue"></i>{{ legendOverdue }}</span>
                </div>

                <div class="module-list">
                    @for (row of rows; track row.key) {
                        <div class="module-row" [class.dimmed]="row.dimmed">
                            <span class="module-name" [class.locked]="!row.counts">
                                {{ row.label }}
                            </span>
                            @if (row.counts) {
                                <span class="module-counts">
                                    <span class="count" [class.open]="row.counts.open" [class.empty]="!row.counts.open">{{ row.counts.open }}</span>
                                    <span class="count" [class.monitoring]="row.counts.monitoring" [class.empty]="!row.counts.monitoring">{{ row.counts.monitoring }}</span>
                                    <span class="count" [class.overdue]="row.counts.overdue" [class.empty]="!row.counts.overdue">{{ row.counts.overdue }}</span>
                                </span>
                            } @else {
                                <span class="unlock-note">{{ upgradeLabel }}</span>
                            }
                        </div>
                    }
                </div>
            }

            @if (rows.length) {
                <button type="button" class="breakdown-toggle" (click)="toggleExpanded()">
                    {{ expanded ? hideBreakdownLabel : showBreakdownLabel }}
                </button>
            }
        }
    </div>
</app-card>
